import FollowUpTAR from "../../../../src/components/content/FollowUpTAR";
import * as React from 'react';
export default {
  FollowUpTAR,
  React
};